var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3a13 13 0 1013 13A13.015 13.015 0 0016 3zm0 21a1.5 1.5 0 110-2.999A1.5 1.5 0 0116 24zm1-6.111V18a1 1 0 11-2 0v-1a1 1 0 011-1 2.5 2.5 0 10-2.5-2.5 1 1 0 11-2 0 4.5 4.5 0 115.5 4.388z",
    fill: "#52575C"
  })));
}

export default SvgQuestion;